import { gql } from '@grandvisionhq/graphql';

const qrCodePaymentResponse = gql`
  fragment QrCodePaymentResponseFragment on PlaceOrderMutationQrCodePaymentResponse {
    qrCodeUrl
    qrCodeExpiresIn
    redirectUrl
    resultType
  }
`;

export { qrCodePaymentResponse };
//# sourceMappingURL=qr-code-payment-response.js.map
